<template>
    <h2 class="useThemeTextColor nowrapheader pr-2 d-flex">
        <v-icon class="mr-2 pb-1" :size="isPhoneBool ? 25 : 23">
            {{ icon }}
        </v-icon>
        <slot name="title">{{ title }}</slot>
    </h2>
</template>


<script>
export default {
    name: 'Title_Base',
    props: {
        title: String,
        icon: String,
    },
    components: {},

    data() {
        return {};
    },

    methods: {},

    computed: {},

    watch: {},
};
</script>


<style lang='scss' scoped></style>